import { DSOptionProps } from '@vr/ds-react'

import { API } from '../api'
import { Unit, UnitsResponse } from './interface'

export const fetch = async (
  idEconomicGroup: string,
  term: string = '',
  page: number = 1,
  pageSize: number = 10,
  startDate?: string,
  endDate?: string
): Promise<{
  items: DSOptionProps[]
  total: number
}> => {
  const params: Record<string, string | number> = {
    idEmpregador: idEconomicGroup,
    termo: term,
    pagina: page,
    tamanhoDaPagina: pageSize,
    ordenacao: 'desc'
  }

  if (startDate) params.DataInicio = startDate
  if (endDate) params.DataFim = endDate

  try {
    const response = await API.get<UnitsResponse>(
      '/logistica/filtro/Unidade',
      params
    )
    const content = response?.content ?? {}
    const results: Unit[] = content.itensRespostaBuscarFiltros ?? []
    const total = content.total ?? 0

    const items: DSOptionProps[] = results.map(account => ({
      label: account.nome,
      value: account.id
    }))

    return { items, total }
  } catch (error) {
    console.error('Erro ao buscar grupo econômico:', error)
    return { items: [], total: 0 }
  }
}
